export const stageMeta = {
  new: { label: 'New', tone: 'bg-amber-500/15 text-amber-300 border-amber-400/30' },
  awaiting_store: { label: 'Awaiting Store', tone: 'bg-yellow-500/15 text-yellow-300 border-yellow-400/30' },
  ready_for_driver: { label: 'Ready for Driver', tone: 'bg-sky-500/15 text-sky-300 border-sky-400/30' },
  out_for_delivery: { label: 'Out for Delivery', tone: 'bg-violet-500/15 text-violet-300 border-violet-400/30' },
  delivered: { label: 'Delivered', tone: 'bg-emerald-500/15 text-emerald-300 border-emerald-400/30' },
  issue: { label: 'Issue', tone: 'bg-rose-500/15 text-rose-300 border-rose-400/30' },
  cancelled: { label: 'Cancelled', tone: 'bg-slate-500/15 text-slate-300 border-slate-400/30' },
};

export const stageOrder = ['new', 'awaiting_store', 'ready_for_driver', 'out_for_delivery', 'delivered', 'issue', 'cancelled'];

export function normalizeStage(value) {
  const raw = String(value || '').toLowerCase().trim();
  if (!raw) return 'new';
  if (['new', 'under_review', 'awaiting_online_review', 'sent_to_store'].includes(raw)) return 'new';
  if (['awaiting_store', 'awaiting_store_response', 'accepted', 'packing', 'preparing', 'store_packing'].includes(raw)) return 'awaiting_store';
  if (['ready_for_driver', 'driver_assigned', 'ready', 'picked_up'].includes(raw)) return 'ready_for_driver';
  if (['out_for_delivery', 'on_route', 'out for delivery'].includes(raw)) return 'out_for_delivery';
  if (['delivered', 'complete', 'completed'].includes(raw)) return 'delivered';
  if (['issue', 'failed_delivery', 'stock_issue', 'delayed'].includes(raw)) return 'issue';
  if (['cancelled', 'canceled'].includes(raw)) return 'cancelled';
  return 'new';
}
